// C.1 — «Дирижёр» Райна (global_rayna), архетип «Усилитель Подавления».
//
// xlsx v6 dsl_trigger1:
//   event: ally_summoned, filter: has_keyword_suppression
//   target: event_subject, effect: amplify_suppression, duration: while_alive
//   → Пока Райна жива, эффект Подавления любого союзного источника удваивается.
//     Реализация: флаг state.suppressionAmplifierActive[ownerIdx] = true пока
//     Райна жива. Триггер пересчитывает Подавление при появлении нового источника.
//
// xlsx v6 dsl_active (Ф2, 1× за матч):
//   target: ally_choose, effect: give_keyword, keyword: suppression
//   duration: permanent
//   → Выдать выбранному союзнику Подавление перманентно.

import { registerImplementedAbility } from '../../warn-unimplemented.js';
import { addPermanentKeyword } from '../../../keywords/permanent.js';
import { KW } from '../../../keywords.js';
import { recomputeSuppression } from '../../../keywords/suppression.js';

export const HERO_ID = 'global_rayna';

// Установить/снять флаг усиления Подавления в зависимости от того, жива ли
// Райна на стороне игрока. Вызывается при изменении состава поля.
export function recomputeRaynaAmplifier(state) {
  if (!state?.players) return;
  if (!state.suppressionAmplifierActive) state.suppressionAmplifierActive = [false, false];
  for (let i = 0; i < state.players.length; i++) {
    const p = state.players[i];
    const heroActive = p?.hero?.id === HERO_ID
      && p.hero?.hp > 0
      && !p.hero?.current?.silenced;
    state.suppressionAmplifierActive[i] = !!heroActive;
  }
  recomputeSuppression(state);
}

// Активка Ф2.
export function raynaActive(state, playerIdx, opts = {}) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return { ok: false, reason: 'wrong_hero' };
  if (p.heroActiveUsedThisMatch) return { ok: false, reason: 'already_used' };

  // Цель выбирается игроком (ally_choose). opts.target — конкретный юнит.
  const target = opts.target;
  if (!target) return { ok: false, reason: 'no_target' };
  if (target.ownerId !== playerIdx) return { ok: false, reason: 'not_own' };
  if (target.type !== 'unit') return { ok: false, reason: 'not_unit' };

  addPermanentKeyword(state, target, KW.SUPPRESSION, HERO_ID, 'Райна');
  // После выдачи keyword пересчитываем Подавление.
  recomputeSuppression(state);

  p.heroActiveUsedThisMatch = true;
  if (state.log) {
    state.log.add(`🎼 Райна [${p.name}]: активка — ${target.name_ru} получил Подавление`);
  }
  return { ok: true };
}

export function raynaActiveAvailable(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.hero || p.hero.id !== HERO_ID) return false;
  if (p.heroActiveUsedThisMatch) return false;
  if (p.hero.current?.silenced) return false;
  // Должен быть хотя бы один союзный юнит.
  if (!p.field) return false;
  for (const row of p.field) {
    if (!row) continue;
    for (const u of row) if (u && (!u.isAlive || u.isAlive())) return true;
  }
  return false;
}

// Список кандидатов для UI/бота (ally_choose).
export function getRaynaActiveTargets(state, playerIdx) {
  const p = state.players?.[playerIdx];
  if (!p?.field) return [];
  const result = [];
  for (const row of p.field) {
    if (!row) continue;
    for (const u of row) {
      if (u && (!u.isAlive || u.isAlive())) result.push(u);
    }
  }
  return result;
}

registerImplementedAbility(HERO_ID, 'trigger', 'active');
